






















import { Component, Vue, Watch } from 'vue-property-decorator';

import PageHeader from '@/shared/components/pageHeader/PageHeader.vue';
import FlowEscalationRateCharts from '@/features/reports/components/flows/FlowEscalationRateCharts.vue';
import FlowEngagementCharts from '@/features/reports/components/flows/FlowEngagementCharts.vue';
import FlowTotalsCharts from '@/features/reports/components/flows/FlowTotalsCharts.vue';
import { Getter, Mutation } from 'vuex-class';
import { SET_REPORT_LOADING } from '@/store/reports/mutationTypes';
import { DateOption } from '../models';

interface ReportsLoaded {
	totals: boolean;
	engagement: boolean;
	escalation: boolean;
}

@Component({
	mixins: [],
	components: {
		FlowTotalsCharts,
		PageHeader,
		FlowEscalationRateCharts,
		FlowEngagementCharts
	}
})
export default class FlowsReports extends Vue {
	@Getter public selectedDateOption!: DateOption;
	@Getter public selectedFlowId!: string;
	@Mutation(SET_REPORT_LOADING) public setReportLoading: (loading: boolean) => void;

	public reportIsLoaded: ReportsLoaded = {
		totals: false,
		engagement: false,
		escalation: false
	};

	@Watch('selectedDateOption')
	public onSelectedDateOptionChange() {
		this.resetLoadingStatus();
		this.setReportLoading(true);
	}

	@Watch('selectedFlowId')
	public onSelectedFlowChange() {
		this.resetLoadingStatus();
		this.setReportLoading(true);
	}

	public mounted() {
		this.setReportLoading(true);
	}

	public handleReportLoad(type: keyof ReportsLoaded) {
		this.reportIsLoaded[type] = true;
		if (this.reportIsLoaded.totals && this.reportIsLoaded.engagement && this.reportIsLoaded.escalation) {
			this.setReportLoading(false);
		}
	}

	private resetLoadingStatus() {
		this.reportIsLoaded = {
			totals: false,
			engagement: false,
			escalation: false
		};
	}
}
